import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedDate } from 'react-intl';
import classNames from 'classnames';
import { addDays, isSameDay } from 'date-fns';
import { shiftDateObjectByTimezone } from 'tz-offsets';
import { localDate } from 'helpers/time';
export var DateBar =
/*#__PURE__*/
function (_Component) {
  _inherits(DateBar, _Component);

  function DateBar(props) {
    var _this;

    _classCallCheck(this, DateBar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DateBar).call(this, props));
    _this.state = {
      week: 0
    };
    _this.handlePrevWeekClick = _this.handlePrevWeekClick.bind(_assertThisInitialized(_this));
    _this.handleNextWeekClick = _this.handleNextWeekClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DateBar, [{
    key: "handlePrevWeekClick",
    value: function handlePrevWeekClick() {
      if (this.state.week > 0) {
        this.setState({
          week: this.state.week - 1
        });
      }
    }
  }, {
    key: "handleNextWeekClick",
    value: function handleNextWeekClick() {
      if (this.state.week < 1) {
        this.setState({
          week: this.state.week + 1
        });
      }
    }
  }, {
    key: "renderDates",
    value: function renderDates() {
      var _this$props = this.props,
          onDateClick = _this$props.onDateClick,
          selectedDateInVenueTimezone = _this$props.selectedDateInVenueTimezone,
          timezone = _this$props.timezone,
          numberOfDaysToShow = _this$props.numberOfDaysToShow;
      var nowInVenueTimezone = shiftDateObjectByTimezone(new Date(), timezone);
      var dayRange = Array.from(Array(numberOfDaysToShow).keys());
      return dayRange.map(function (dayNum) {
        var dateInVenueTimezone = addDays(nowInVenueTimezone, dayNum);
        return React.createElement("li", {
          key: dateInVenueTimezone.getTime(),
          onClick: function onClick() {
            return onDateClick(localDate(dateInVenueTimezone));
          },
          className: classNames('schedule__datebar__date', {
            selected: isSameDay(selectedDateInVenueTimezone, dateInVenueTimezone)
          })
        }, React.createElement("div", {
          className: "schedule__datebar__date__day"
        }, React.createElement(FormattedDate, {
          id: "datebar.weekday",
          value: dateInVenueTimezone,
          weekday: "short"
        })), React.createElement("div", {
          className: "schedule__datebar__date__date"
        }, React.createElement(FormattedDate, {
          id: "datebar.day",
          value: dateInVenueTimezone,
          day: "numeric"
        })));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var sevenOrLessDays = this.props.numberOfDaysToShow <= 7;
      return React.createElement("div", {
        className: classNames("schedule__datebar ".concat(this.props.extraClass), {
          'schedule__datebar--page2': this.state.week >= 1
        })
      }, React.createElement("div", {
        onClick: this.handlePrevWeekClick,
        className: classNames('schedule__datebar__prev', {
          hidden: sevenOrLessDays,
          'schedule__datebar__prev--disabled': this.state.week === 0
        })
      }), React.createElement("div", {
        className: "schedule__datebar__scroll"
      }, React.createElement("ul", null, this.renderDates())), React.createElement("div", {
        onClick: this.handleNextWeekClick,
        className: classNames('schedule__datebar__next', {
          hidden: sevenOrLessDays,
          'schedule__datebar__next--disabled': this.state.week >= 1
        })
      }));
    }
  }]);

  return DateBar;
}(Component);
DateBar.propTypes = {
  extraClass: PropTypes.string,
  selectedDateInVenueTimezone: PropTypes.string.isRequired,
  onDateClick: PropTypes.func.isRequired,
  numberOfDaysToShow: PropTypes.number.isRequired,
  timezone: PropTypes.string.isRequired
};